<template>
  <!-- <div class="side-menu lightgray mx-n10 m-lg-0 pr-16 pr-lg-6 py-6"> -->
  <div class="side-menu pr-lg-6">
    <v-treeview
      :items="$t(menu).children"
      open-all
      :change="changeTrigger()"
      expand-icon=""
    >
      <!-- expand-icon="mdi-chevron-down" -->
      <template slot="label" slot-scope="props">
        <router-link
          v-if="
            props.item.slug &&
              props.item.slug != 'news' &&
              props.item.slug != 'technologies' &&
              props.item.slug != 'services'
          "
          :to="page + props.item.slug"
          class="text-decoration-none sidemenu-item black--text"
          :class="{
            'sidemenu-item-active': $route.fullPath.includes(props.item.slug),
          }"
          @click.native="scrollToTop"
        >
          {{ props.item.name }}
        </router-link>

        <router-link
          v-else-if="
            props.item.slug == 'technologies' ||
              props.item.slug == 'services' ||
              props.item.slug == 'news'
          "
          :to="'/' + props.item.slug"
          class="text-decoration-none sidemenu-item black--text"
          :class="{
            'sidemenu-item-active': $route.fullPath.includes(props.item.slug),
          }"
          @click.native="scrollToTop"
        >
          {{ props.item.name }}
        </router-link>

        <div v-else class="sidemenu-item sidemenu-item-disabled">
          {{ props.item.name }}
        </div>
      </template>
    </v-treeview>
  </div>
</template>

<script>
export default {
  name: 'SideMenu',
  props: {
    page: {
      type: String,
      required: true,
    },
    menu: {
      type: String,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {
    changeTrigger() {
      let allMenuItems = []

      this.$t(this.menu).children.forEach(child => {
        if (child.slug) {
          allMenuItems.push(child)
        } else {
          child.children.forEach(grandchild => {
            if (grandchild.slug) {
              allMenuItems.push(grandchild)
            } else {
              grandchild.children.forEach(greatGrandchild => {
                if (greatGrandchild.slug) {
                  allMenuItems.push(greatGrandchild)
                }
              })
            }
          })
        }
      })

      let menuItem = allMenuItems.filter(
        menu => menu.slug === this.$route.params.slug
      )
      if (menuItem[0]) {
        this.$emit('menuContent', menuItem[0].content)
      } else {
        this.$emit('menuContent', {})
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
  },
}
</script>

<style lang="scss">
.page-wrapper {
  margin-bottom: 120px;
}

.page-sidebar {
  top: 0px;
  position: sticky;
  height: 100%;
  @media #{map-get($display-breakpoints, 'md-and-down')} {
    top: 0px;
    position: relative;
  }
}

.page-content {
  margin-top: 0px;
  @media #{map-get($display-breakpoints, 'md-and-down')} {
    margin-top: 0px;
  }
}

.side-menu {
  // border-right: solid grey 2px;
  // width: 100%;
  margin-left: -24px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .v-treeview {
      margin-left: 50px;

      transform: translateX(-30px);
      width: 90vw;
    }
  }
}

.sidemenu-item {
  font-family: $heading-font-family;
  border-bottom: solid lightgray 1px;
  display: block; /* This will put the pseudo element on its own line. */
  margin: 0 auto; /* This will center the border. */
  width: 100%; /* Change this to whatever width you want. */
  font-weight: normal;
  font-size: 14px;
  color: #272727 !important;
  line-height: 35px;
  height: 35px;
  /*min-width: 100%;
    padding: 0 20px;
  display: inline-block;*/

  &:hover {
    background-color: rgba(#1bb493, 0.2);
  }
}

.sidemenu-item-disabled {
  text-transform: uppercase;
  font-size: 11px;
  color: #1bb493 !important;
  margin-bottom: -13px;
  font-weight: bold;
  border: none;
  background-color: transparent !important;
}

.sidemenu-item-active {
  background-color: rgba(#1bb493, 0.2) !important;
}

.v-treeview-node__root {
  padding: 0px !important;
  min-height: 35px !important;
  .v-treeview-node__content {
    // transform: translateX(-5%);
  }
}

.v-treeview-node__content {
  margin: 0 !important;
}

@media #{map-get($display-breakpoints, 'md-and-down')} {
  .side-menu {
    button {
      margin-right: 1vw !important;
    }
  }
}
</style>
